import { Box, BoxProps } from '@mui/material'
import React from 'react'

const DesktopDropdown = React.forwardRef(({ sx, children, ...props }:BoxProps, ref) => (
  <Box
    sx={{
      background: 'rgba(224, 230, 246, 0.94)',
      borderRadius: 2,
      ...sx
    }}
    {...props}
    ref={ref}
  >
    {children}
  </Box>
))

DesktopDropdown.displayName = 'DesktopDropdown'
export default DesktopDropdown
